// import axios from "axios";
import instance from "../../../../../axios";
import { instanceTokenLess } from "../../../../../axios";

export const BASE_URL = `${process.env.REACT_APP_VI_API_URL}`;
export const BASE_SAAS_URL = `${process.env.REACT_APP_API_URL}`;
export const API_URL = `${process.env.REACT_APP_API_URL_MOBILY}` + "/how-to-play";
export const BASE_GAMERJI_URL = `${process.env.REACT_APP_GAMERJI_API_URL}`;

// export function getHowtoJoinList(queryParams) {
//   return instance.post(`${API_URL}/list`, queryParams)
//     .then(res => {
//       return res;
//     })
// };

export function getHowtoJoinList(queryParams) {
  const selectedCompany = localStorage.getItem("selectedCompany");
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    ...queryParams,
    company: selectedCompany,
  };
  const headers = {
    "company-code": selectedCompany,
  };
  return instanceTokenLess
    .post(`${API_URL}/list`, payload, { headers })
    .then((res) => {
      return res;
    });
}

export function fetchCompanyDropdownList(queryParams) {
  return instance
    .post(`${process.env.REACT_APP_API_URL}/company/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}
export function createHowToJoin(body) {
  return instance.post(`${BASE_URL}/howtojoin/add`, body).then((res) => {
    return res;
  });
}
export function deleteHowtoJoin(id) {
  const selectedCompany = localStorage.getItem("selectedCompany");
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    //  ...body,
    company: selectedCompany,
  };
  const headers = {
    "company-code": selectedCompany,
  };
  return instanceTokenLess
    .post(`${API_URL}/delete/${id}`, payload, { headers })
    .then((res) => {
      return res;
    });
}
export function updateHowToJoin(body, id) {
  const selectedCompany = localStorage.getItem("selectedCompany");
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    ...body,
    company: selectedCompany,
  };
  const headers = {
    "company-code": selectedCompany,
  };
  return instanceTokenLess
    .post(`${API_URL}/update/${id}`, payload, { headers })
    .then((res) => {
      return res;
    });
}

export function statusUpdateHowToJoin(body, id) {
  const selectedCompany = localStorage.getItem('selectedCompany');
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
     ...body,
    company: selectedCompany, 
  };
  const headers = {
    "company-code": selectedCompany
  };
  return instanceTokenLess.post(`${API_URL}/statusUpdate/${id}`,payload,{headers})
    .then(res => {
      return res;
    })
};
// export function fetchSingle(id) {
//   return instance.get(`${BASE_URL}/howtojoin/get/${id}`)
//     .then(res => {
//       return res;
//     })
// };

export function fetchSingle(id) {
  const selectedCompany = localStorage.getItem("selectedCompany");
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    // ...queryParams,
    company: selectedCompany,
  };
  const headers = {
    "company-code": selectedCompany,
  };
  return instanceTokenLess
    .post(`${API_URL}/get/${id}`, payload, { headers })
    .then((res) => {
      return res;
    });
}

export function createItem(item) {
  const selectedCompany = localStorage.getItem("selectedCompany");
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    ...item,
    company: selectedCompany,
  };
  const headers = {
    "company-code": selectedCompany,
  };
  return instanceTokenLess.post(`${API_URL}/create`, payload, { headers });
}
export function updateItem(item) {
  const selectedCompany = localStorage.getItem("selectedCompany");
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    ...item,
    company: selectedCompany,
  };
  const headers = {
    "company-code": selectedCompany,
  };
  return instanceTokenLess.post(`${API_URL}/update/${item._id}`, payload, {
    headers,
  });
}

export function getAllGamesList() {
  const selectedCompany = localStorage.getItem("selectedCompany");
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    // ...queryParams,
    company: selectedCompany,
  };
  const headers = {
    "company-code": selectedCompany,
  };
  console.log("headers", headers, payload);
  return instanceTokenLess
    .post(`${BASE_SAAS_URL}/gamesDropdownList`, payload, { headers })
    .then((res) => {
      return res;
    });
}
export function getCountry(queryParams) {
  return instance
    .post(`${BASE_SAAS_URL}/country/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}
export function uploadImage(file) {
  let formData = new FormData();
  formData.append("file", file);
  let url = BASE_SAAS_URL + "/image/upload";
  return instance.post(`${url}`, formData);
}
